<template>
  <NuxtLayout>
    <NuxtLoadingIndicator :duration="1500" color="#6073EE" />
    <!-- No global page-key override. Most dynamic [slug] pages now use reactive
         useAsyncData + reactive derived state, so a param-only change (category→category,
         solution→solution) REUSES the component and swaps data in place instead of a full
         remount — removing the nav flicker/footer-jump and speeding up navigation.
         Exception: the JSON-LD pages (articles/glossary/webinars) set their own
         definePageMeta key to keep remounting, because nuxt-schema-org's graph does not
         cleanly replace on client nav between schema pages. See
         content-drafts/specs/remove-global-page-key.md. -->
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
const route = useRoute()
const schema = {
  name: 'Elker',
  description: 'Elker is an innovative speak-up and whistleblowing platform, empowering employees to make their voices heard, anonymously and safely.',
  url: 'https://elker.com',
  logo: 'https://cdn.elker.com/elker_logo_651cfb3fa6.png',
  sameAs: [
    'https://www.linkedin.com/company/elkerofficial/?originalSubdomain=au',
    'https://instagram.com/elkerofficial',
    'https://facebook.com/elkerofficial',
    'https://twitter.com/elkerofficial'
  ]
}

useSchemaOrg([
  defineOrganization({
    name: schema.name,
    logo: schema.logo,
    sameAs: schema.sameAs
  }),
  defineWebSite({
    name: schema.name,
  }),
  defineWebPage(
    {
      name: schema.name,
      description: schema.description,
      url: schema.url,
      image: schema.logo
    }
  )
])

</script>

<style>
html,
body {
  background-color: #f9f8f6;
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  src:url('https://media.elker.com/998a58b6-b5e4-4191-986d-dfdf02a5b3e8/Inter-Regular.woff2') format("woff2");
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  src:url('https://media.elker.com/1cd1ff10-35a3-41b3-9b7b-851ea16a657a/Inter-Medium.woff2') format("woff2");
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  src:url('https://media.elker.com/7af40ce3-733e-4710-b5f0-f29d6ba080d4/Inter-Bold.woff2') format("woff2");
}

@font-face {
  font-display: swap;
  font-family: 'Lora';
  font-style: normal;
  font-weight: 400;
  src:url('https://media.elker.com/96a14da1-e693-4510-86ff-8737590c47cd/Lora-Regular.woff2') format("woff2");
}
</style>